const PopUpModulBtn = ({
  btnText,
  modalId,
  title,
  children,
  text,
  btnStyle = "btn-secondary",
}) => {
  return (
    <>
      <button
        className={`btn ${btnStyle}`}
        onClick={() => document.getElementById(modalId).showModal()}
      >
        {btnText}
      </button>
      <dialog id={modalId} className="modal">
        <div className="modal-box">
          <h3 className="text-lg font-bold text-white">{title}</h3>
          <p className="py-4">{text}</p>
          {children}
          <div className="modal-action">
            <form method="dialog">
              <button className="btn">Stäng</button>
            </form>
          </div>
        </div>
      </dialog>
    </>
  );
};

export default PopUpModulBtn;
